import { render, staticRenderFns } from "./returnProductDetails.vue?vue&type=template&id=47487b35&scoped=true"
import script from "./returnProductDetails.vue?vue&type=script&lang=js"
export * from "./returnProductDetails.vue?vue&type=script&lang=js"
import style0 from "./returnProductDetails.vue?vue&type=style&index=0&id=47487b35&prod&lang=scss&scoped=true"
import style1 from "./returnProductDetails.vue?vue&type=style&index=1&id=47487b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47487b35",
  null
  
)

export default component.exports